module.exports = __webpack_public_path__ + "static/media/APPROVED-What_is_an_Orthodontist_Flyer-NEW-LOGO-2011.919e0afb.pdf";